var _defs, _use;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckboxDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 15 15"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "checkbox-default_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v15H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "checkbox-default_svg__a",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "checkbox-default_svg__d"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#checkbox-default_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.502,
    d: "M0 0h15v15H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "checkbox-default_svg__c",
    clipPath: "url(#checkbox-default_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.809 13.125H3.19c-.726 0-1.316-.59-1.316-1.316V3.19c0-.726.59-1.316 1.316-1.316h8.618c.726 0 1.316.59 1.316 1.316v8.618c0 .726-.59 1.316-1.316 1.316zM3.19 2.754a.437.437 0 00-.437.437v8.618c0 .242.195.437.437.437h8.618a.437.437 0 00.437-.437V3.19a.437.437 0 00-.437-.437zm0 0",
    fill: "#71869b"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#checkbox-default_svg__c",
    mask: "url(#checkbox-default_svg__d)"
  })));
}

export default SvgCheckboxDefault;